var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input',_vm._b({directives:[{name:"inputTimeMask",rawName:"v-inputTimeMask"}],staticClass:"input_color",attrs:{"value":_vm.time,"type":"text","placeholder":"00:00:00"},on:{"input":_vm.updateTime}},'b-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }